import TrackingEvents from "../../components/tracking/TrackingEvents";
import React from 'react';

export default function TrackingPage() {
  const today = new Date();
  
  return (
    <TrackingEvents 
      day={today.getDate().toString()} 
      month={today.getMonth().toString()} 
      year={today.getFullYear().toString()} 
    />
  );
}

